import Vertical from './Vertical';

const AppLayouts = {
  Vertical,
};
export default AppLayouts;
